import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MatCardModule } from '@angular/material/card';
import { IrisCardComponent } from './iris-card.component';
import { IrisCardHeaderComponent } from './iris-card-header/iris-card-header.component';
import { IrisCardFooterComponent } from './iris-card-footer/iris-card-footer.component';
import { IrisCardBodyComponent } from './iris-card-body/iris-card-body.component';

@NgModule({
  declarations: [
    IrisCardBodyComponent,
    IrisCardComponent,
    IrisCardFooterComponent,
    IrisCardHeaderComponent,
  ],
  exports: [IrisCardComponent],
  imports: [CommonModule, MatCardModule],
})
export class IrisCardModule {}
